/* ============================================================================
   c111-medir.js  ·  111 Cientonce
   Mide un render de prenda por píxel y saca su calibración solo.
   ---------------------------------------------------------------------------
   PARA QUÉ EXISTE
   Para que conectar un traje nuevo no dependa de nadie. Basta con enlazar la
   imagen al producto (metacampo custom.render_frente): el navegador la mide al
   abrir el personalizador y saca la escala en cm y las zonas por su cuenta.

   Si el producto trae además custom.render_calibracion, ESE manda — son números
   revisados a mano. Esto es el respaldo automático para cuando no está.
   ---------------------------------------------------------------------------
   LAS FÓRMULAS NO SON INVENTADAS
   Salieron de las referencias que sí se verificaron dibujando las zonas y
   apliques de prueba encima: manta y aqua para el frente, y el render de
   espalda manga corta para la espalda. Reproducen esas calibraciones.
   ---------------------------------------------------------------------------
   SI ALGO FALLA no pasa nada: devuelve null y el personalizador se queda con el
   modelo de referencia, que siempre funciona.
   ========================================================================== */
(function(){
'use strict';

var PECHO_CM  = 36;    /* ancho de la prenda plana donde empieza el short, talla M */
var K_FRENTE  = 31.2;  /* constante de escala del frente  */
var K_ESPALDA = 32.1;  /* constante de escala de la espalda */
var ANCHO_MED = 600;   /* se mide en chiquito: mismo resultado, mucho más rápido */

function silueta(img){
  var W = ANCHO_MED;
  var H = Math.round(W * img.naturalHeight / img.naturalWidth);
  var c = document.createElement('canvas'); c.width=W; c.height=H;
  var x = c.getContext('2d', {willReadFrequently:true});
  x.drawImage(img,0,0,W,H);
  var d = x.getImageData(0,0,W,H).data;
  function px(i,j){ var o=(j*W+i)*4; return [d[o],d[o+1],d[o+2],d[o+3]]; }
  var bg = px(2,2);
  function esPrenda(i,j){
    var p = px(i,j);
    if(p[3] < 40) return false;
    if(bg[3] < 40) return true;
    return Math.abs(p[0]-bg[0])+Math.abs(p[1]-bg[1])+Math.abs(p[2]-bg[2]) > 34;
  }
  var rows=[], j, i;
  for(j=0;j<H;j++){
    var a=-1, b=-1, n=0;
    for(i=0;i<W;i++){ if(esPrenda(i,j)){ if(a<0)a=i; b=i; n++; } }
    rows.push(a<0?null:{x1:a,x2:b,n:n});
  }
  var top=-1, bot=-1;
  for(j=0;j<H;j++){ if(rows[j] && rows[j].n > W*0.03){ top=j; break; } }
  for(j=H-1;j>=0;j--){ if(rows[j] && rows[j].n > W*0.03){ bot=j; break; } }
  if(top<0 || bot<=top) return null;

  /* cintura: la fila más angosta entre el 42% y el 68% de la prenda — ahí
     empieza el short */
  var best=null;
  for(j=Math.round(top+(bot-top)*0.42); j<=Math.round(top+(bot-top)*0.68); j++){
    var r=rows[j]; if(!r) continue;
    var w=r.x2-r.x1;
    if(!best || w<best.w) best={y:j,w:w};
  }
  if(!best) return null;

  /* entrepierna: primera fila bajo la cintura donde la silueta se parte en dos */
  var crotch=null;
  for(j=best.y;j<=bot;j++){
    var rr=rows[j]; if(!rr) continue;
    var mid=Math.round((rr.x1+rr.x2)/2), hueco=0;
    for(i=mid-Math.round(W*0.02); i<=mid+Math.round(W*0.02); i++) if(!esPrenda(i,j)) hueco++;
    if(hueco > W*0.03){ crotch=j; break; }
  }
  if(crotch===null) return null;

  return { ratio:+(img.naturalHeight/img.naturalWidth).toFixed(4),
           top:+(top/H*100).toFixed(1), bot:+(bot/H*100).toFixed(1),
           frac:+(best.w/W).toFixed(4), cy:+(best.y/H*100).toFixed(1),
           crotch:+(crotch/H*100).toFixed(1) };
}

function r1(v){ return Math.round(v*10)/10; }

function calFrente(m){
  var half = m.frac*100/2;
  return { ratio:m.ratio, zoom:1, frameCm:Math.round(K_FRENTE/m.frac),
    zip:{ x:50, y1:r1(m.top+4.5), y2:r1(m.crotch-26) },
    zonas:[
      {k:'torso', l:'Torso',           x1:r1(50-half*0.62), y1:r1(m.top+8),     x2:r1(50+half*0.62), y2:r1(Math.min(m.crotch-33,m.cy+2)), cap:20},
      {k:'musloD',l:'Muslo derecho',   x1:r1(50-half),      y1:r1(m.crotch-15), x2:47,               y2:r1(m.crotch+1.4),                 cap:12},
      {k:'musloI',l:'Muslo izquierdo', x1:53,               y1:r1(m.crotch-15), x2:r1(50+half),      y2:r1(m.crotch+1.4),                 cap:12}
    ]};
}

/* En la espalda los lados se invierten: el muslo derecho de quien la usa queda
   a la derecha de la imagen. */
function calEspalda(m){
  var half = m.frac*100/2;
  return { ratio:m.ratio, zoom:1.1, frameCm:Math.round(K_ESPALDA/m.frac),
    zonas:[
      {k:'espalda', l:'Espalda',         x1:r1(50-half*0.59), y1:r1(m.top+7),     x2:r1(50+half*0.59), y2:r1(m.cy+1.1),     cap:24},
      {k:'musloIB', l:'Muslo izquierdo', x1:r1(50-half+2),    y1:r1(m.crotch-11), x2:48,               y2:r1(m.crotch+5.2), cap:12},
      {k:'musloDB', l:'Muslo derecho',   x1:52,               y1:r1(m.crotch-11), x2:r1(50+half-2),    y2:r1(m.crotch+5.2), cap:12}
    ]};
}

function cargar(url){
  return new Promise(function(ok,fail){
    var im=new Image();
    im.crossOrigin='anonymous';
    im.onload=function(){ ok(im); };
    im.onerror=function(){ fail(new Error('no cargó')); };
    im.src=url;
  });
}

function vistaDeUrl(url, cara){
  if(!url) return Promise.resolve(null);
  return cargar(url).then(function(im){
    var m = silueta(im);
    if(!m) return null;
    /* cordura: si la medida es absurda, no se usa */
    if(m.frac < 0.12 || m.frac > 0.60) return null;
    if(m.crotch <= m.cy) return null;
    if(m.bot - m.top < 40) return null;
    var v = (cara==='back') ? calEspalda(m) : calFrente(m);
    v.img = url;
    v.medido = true;
    return v;
  }).catch(function(){ return null; });
}

window.C111medir = { vistaDeUrl:vistaDeUrl, silueta:silueta,
                     calFrente:calFrente, calEspalda:calEspalda, PECHO_CM:PECHO_CM };
})();
